import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'
import moment from 'moment'

import { getPricingGroupWithPricesAppliedToAccount } from '@/lib/helpers/AccountUtils'
import { orderLineTypes, orderLineItemEntities } from '@/config'
import { findOptionById } from '@/lib/helpers/CatalogUtils'
import { generateUUID } from '@/lib/helpers/UUID'

const { PRODUCT, CATALOG_PRODUCT_MODIFIER_OPTION } = orderLineItemEntities
const { SALE } = orderLineTypes

export class ToOrder {
  constructor (params = {}) {
    const { cartProducts, stationId, reservationOrderLines } = camelcaseKeys(params)
    this.moment = moment().toISOString()
    this.stationId = stationId
    this.orderLines = [
      ...cartProducts.map(cartProduct => new ToCartProductOrderLine(cartProduct)),
      ...reservationOrderLines,
    ]
  }
  serialize () {
    return snakecaseKeys({
      orderLines: this.orderLines,
      moment: this.moment,
      stationId: this.stationId,
    }, { deep: true })
  }
}
export class ToCartProductOrderLine {
  constructor (params = {}) {
    const { id, product, quantity, name, optionIds } = camelcaseKeys(params)
    const pricingGroup = getPricingGroupWithPricesAppliedToAccount(product.pricingGroupsWithPrices)

    this.id = id || generateUUID()
    this.name = name || null
    this.itemId = product ? product.id : null
    this.quantity = quantity
    this.modifierOptions = optionIds.map(optionId => {
      const option = findOptionById({ product, optionId })
      const optionPricingGroup = getPricingGroupWithPricesAppliedToAccount(option.price)
      return {
        modifierOptionId: optionId,
        price: optionPricingGroup.prices[0].map((item) => new ToPrice(item)),
      }
    })
    this.addedAt = moment().toISOString()
    this.orderLineType = SALE
    this.itemEntity = PRODUCT
    this.price = pricingGroup.prices[0].map((item) => new ToPrice(item))
  }
}

export class ToCartProductOptionOrderLine {
  constructor (params = {}) {
    const { product, quantity, optionId, parentOrderLine } = camelcaseKeys(params)
    const modifier = product.modifiers.find(({ options }) => options.some(({ id }) => id === optionId))
    const option = modifier ? modifier.options.find(({ id }) => id === optionId) : null
    const pricingGroup = getPricingGroupWithPricesAppliedToAccount(option.price)

    this.name = option ? option.name : null
    this.itemId = optionId
    this.quantity = quantity
    this.addedAt = moment().toISOString()
    this.orderLineType = SALE
    this.itemEntity = CATALOG_PRODUCT_MODIFIER_OPTION
    this.parentOrderLine = parentOrderLine
    this.price = pricingGroup.prices[0].map((item) => new ToPrice(item))
  }
}

class ToPrice {
  constructor (params = {}) {
    const { currency, amount } = camelcaseKeys(params)
    this.amount = typeof amount === 'number' ? amount : 0
    this.currencyId = currency ? currency.id : null
    this.currency = currency || null
  }
}
